<template>
  <v-layout row justify-center>
      <v-card>
        <v-card-title>
          <v-toolbar color="#1f97b9" dark>
            <v-icon>far fa-user</v-icon>
            <v-toolbar-title>Crea tu Cuenta</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="registerForm">
            <v-container grid-list-md py-0>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-alert
                    :value="alert.state"
                    :type="alert.tipo"
                    :icon="alert.icon"
                    transition="scale-transition"
                    class="py-1"
                  >
                    {{alert.texto}}
                  </v-alert>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.nombre" label="Nombre y Apellido del contacto" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.telefono" label="Teléfono" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.email" label="Email" required :rules="rules.emailRules"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.rut" label="R.U.T Empresa" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.razonSocial" label="Razon Social" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.giroComercial" label="Giro Comercial" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.direccion" label="Dirección" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.comuna" label="Comuna" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="data.ciudad" label="Ciudad" required :rules="rules.required"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="data.password"
                    :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                    :rules="rules.required"
                    :type="show ? 'text' : 'password'"
                    label="Contraseña"
                    @click:append="show = !show"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click="createUser">Crear Cuenta</v-btn>
        </v-card-actions>
      </v-card>
  </v-layout>
</template>

<script>
  import * as firebase from 'firebase/app'
  import 'firebase/auth'
  import { EventBus } from '../../events.js'
  export default{
    name: 'FormRegister',
    data () {
      return {
        dialog: false,
        show: false,
        data: {
          nombre: '',
          telefono: '',
          email: '',
          password: '',
          rut: '',
          razonSocial: '',
          giroComercial: '',
          direccion: '',
          comuna: '',
          ciudad: '',
          mudanzas: [],
          fletes: [],
          tipoCliente: 'Normal',
          clase: 'cliente',
          cuentaCorriente: {
            montoMaximo: 0,
            usado: 0
          },
          fechaFacturacion: ''
        },
        alert: {
          state: false,
          texto: '',
          icon: 'fas fa-info-circle',
          tipo: 'info'
        },
        rules: {
          required: [value => !!value || 'Campo obligatorio'],
          min: [v => v.length >= 8 || 'Mínimo 8 caracteres'],
          emailRules: [
            v => !!v || 'Campo obligatorio',
            v => /.+@.+/.test(v) || 'Verifica que el email sea válido'
          ]
        }
      }
    },
    methods:{
      createUser(){
        if(this.$refs.registerForm.validate()){
          const db = firebase.firestore()
          const here = this
          firebase.auth().createUserWithEmailAndPassword(this.data.email, this.data.password)
            .then(async function(data){
              here.data.created = firebase.firestore.FieldValue.serverTimestamp()
              here.$auth.saveUserInfo(data.user.uid, here.data)
              here.$auth.login(here.data.email, here.data.password)
              db.collection('users').doc(data.user.uid).set(here.data)
              here.alert.state = true
              here.alert.texto = 'Tu cuenta ha sido creada, has sido logeado automáticamente.'
              here.alert.tipo = 'success'
              here.alert.icon = 'fas fa-check-circle'
              setTimeout(function() {
                here.dialog = false
              }, 2000);
              here.$store.state.idCliente = data.user.uid
            })
            .catch(function(error) {
              here.alert.state = true
              here.alert.texto = error.message
              here.alert.tipo = 'error'
              here.alert.icon = 'fas fa-exclamation-triangle'
            });
        }
      }
    },
    mounted(){
      EventBus.$on('openRegister', data => {
        this.dialog = data
      })

    }
  }
</script>